import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DeviceService } from '@stockcare-services/devices-service/devices.service';
import { IDevice } from '@stockcare-models/IDevice';
import { environment } from '@stockcare-environments/environment';
import { ThemeService } from '@stockcare-services/theme/theme.service';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';

@Component({
  standalone: false,
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  device: IDevice;
  environment;
  logo: string;
  version: string = '';

  constructor(
    private modelReference: MatDialogRef<AboutComponent>,
    deviceService: DeviceService,
    themeService: ThemeService,
    settingsService: SettingsService
  ) {
    this.device = deviceService.getDeviceFromLocalStorage();
    this.environment = environment;
    if (themeService.getTheme() != null) {
      this.logo = '../../../assets/img/' + themeService.getTheme().logo;
    } else {
      this.logo = '../../../assets/img/stockcare-default-logo.png';
    }
    settingsService.getVersion().subscribe((ver) => {
      this.version = ver;
    });
  }

  ngOnInit() {}

  cancel() {
    this.modelReference.close();
  }
}
